var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"relative min-h-full w-full bg-gray-800"},[_c('div',{staticClass:"container mx-auto py-16"},[_c('router-view')],1),_c('global-footer-for-simple')],1)}
var staticRenderFns = []

export { render, staticRenderFns }